import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1024.000000 1024.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd" transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)" >


<path d="M2728 5993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2928 5993 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M2590 5973 c-30 -8 -59 -18 -63 -23 -5 -4 22 0 60 10 37 10 79 20 93
23 22 4 21 4 -5 4 -16 0 -55 -6 -85 -14z"/>
<path d="M3110 5950 c8 -5 20 -10 25 -10 6 0 3 5 -5 10 -8 5 -19 10 -25 10 -5
0 -3 -5 5 -10z"/>
<path d="M2445 5925 c-40 -18 -16 -19 26 0 19 8 27 14 19 14 -8 0 -28 -6 -45
-14z"/>
<path d="M2373 5895 c-18 -8 -33 -16 -33 -19 0 -6 51 14 65 26 13 11 5 10 -32
-7z"/>
<path d="M2285 5849 c-16 -10 -26 -19 -22 -19 11 0 67 29 67 35 0 9 -15 4 -45
-16z"/>
<path d="M2155 5760 c-3 -6 1 -7 9 -4 18 7 21 14 7 14 -6 0 -13 -4 -16 -10z"/>
<path d="M2059 5668 c-97 -100 -129 -149 -44 -68 38 36 68 70 67 77 -1 6 5 14
15 17 16 5 50 46 39 46 -3 0 -37 -33 -77 -72z"/>
<path d="M4691 5618 c-27 -71 -88 -227 -126 -323 -106 -268 -145 -371 -145
-378 0 -4 35 -7 77 -5 l78 3 26 65 26 65 148 0 149 0 22 -65 23 -65 80 -3 c47
-2 81 1 81 7 0 9 -78 212 -205 531 l-74 185 -75 3 c-71 3 -77 1 -85 -20z m132
-299 c21 -58 37 -111 37 -117 0 -8 -26 -12 -85 -12 -61 0 -85 3 -85 13 0 24
83 238 90 230 4 -4 23 -56 43 -114z"/>
<path d="M5180 5276 l0 -368 208 4 c189 3 211 5 252 25 87 43 127 146 95 243
-14 42 -25 56 -61 79 l-44 27 35 33 c82 77 67 223 -29 285 -34 22 -51 26 -111
26 -40 0 -133 3 -208 7 l-137 6 0 -367z m365 199 c30 -30 33 -77 6 -104 -25
-25 -69 -33 -156 -29 l-70 3 -2 65 c-1 36 0 71 2 78 3 8 32 12 100 12 88 0 98
-2 120 -25z m35 -295 c23 -29 25 -49 9 -84 -16 -35 -57 -46 -165 -46 l-94 0 0
81 0 81 116 -4 c109 -3 116 -4 134 -28z"/>
<path d="M5828 5634 c-5 -4 -8 -169 -8 -367 l0 -359 213 4 c199 3 215 5 258
27 28 14 56 39 72 64 56 85 30 227 -48 264 l-35 17 31 32 c60 62 69 174 20
243 -46 64 -84 74 -301 79 -107 2 -198 1 -202 -4z m369 -156 c25 -25 22 -83
-5 -111 -20 -20 -33 -22 -120 -22 l-97 0 -3 78 -3 79 105 -4 c84 -2 109 -7
123 -20z m17 -289 c37 -29 37 -89 -1 -119 -24 -18 -37 -20 -132 -18 l-106 3
-3 78 -3 77 109 0 c95 0 113 -3 136 -21z"/>
<path d="M6645 5543 c-21 -54 -70 -179 -110 -278 -100 -250 -135 -341 -135
-348 0 -4 35 -7 78 -7 l78 0 25 68 24 67 151 3 151 3 12 -43 c29 -96 32 -98
121 -98 44 0 80 3 80 6 0 3 -7 18 -14 32 -14 25 -39 88 -116 292 -18 47 -60
155 -94 240 l-61 155 -77 3 -76 3 -37 -98z m155 -213 c18 -52 37 -103 42 -112
6 -13 5 -18 -4 -19 -25 -2 -163 3 -166 6 -2 2 16 55 39 119 23 64 46 113 50
109 4 -5 21 -51 39 -103z"/>
<path d="M7167 5633 c-4 -3 -7 -168 -7 -365 l0 -358 75 0 75 0 0 115 0 115 59
0 c43 0 60 -4 65 -15 3 -8 35 -60 72 -115 l66 -100 84 0 c49 0 84 4 84 10 0 5
-22 40 -48 77 -26 38 -62 89 -80 115 l-32 46 45 26 c28 17 55 44 72 74 24 40
28 58 28 127 0 134 -50 204 -171 241 -49 15 -374 21 -387 7z m364 -153 c41
-22 63 -106 39 -151 -20 -36 -63 -49 -165 -49 l-95 0 0 105 0 105 101 0 c55 0
109 -5 120 -10z"/>
<path d="M7818 5428 c-2 -117 -4 -280 -4 -363 l1 -150 258 -3 257 -2 0 75 0
75 -185 0 -185 0 0 70 0 70 165 0 165 0 0 75 0 75 -165 0 -165 0 0 70 0 70
185 0 185 0 0 75 0 75 -253 0 -254 0 -5 -212z"/>
<path d="M2935 5520 c3 -5 15 -10 26 -10 11 0 17 5 14 10 -3 6 -15 10 -26 10
-11 0 -17 -4 -14 -10z"/>
<path d="M3000 5516 c0 -8 -8 -17 -17 -19 -14 -4 -12 -5 5 -6 12 0 22 1 22 3
0 2 3 11 6 20 3 9 1 16 -5 16 -6 0 -11 -6 -11 -14z"/>
<path d="M3201 5508 c-1 -10 4 -18 9 -18 6 0 10 -7 10 -16 0 -8 -5 -12 -11 -8
-8 4 -9 -1 -4 -16 7 -21 5 -22 -44 -19 -58 5 -55 -8 4 -14 l40 -4 -42 -1 c-43
-2 -58 -17 -25 -25 9 -2 4 -3 -13 -1 -22 3 -26 1 -15 -6 22 -14 90 -13 90 3 0
7 9 29 20 50 24 43 26 67 6 67 -8 0 -17 6 -19 13 -3 7 -6 5 -6 -5z"/>
<path d="M1891 5462 c-34 -54 -123 -252 -118 -266 2 -5 16 22 32 60 17 38 51
111 78 162 26 50 46 92 43 92 -2 0 -18 -21 -35 -48z"/>
<path d="M3260 5499 c0 -9 108 -24 116 -17 2 3 -23 10 -56 15 -33 5 -60 6 -60
2z"/>
<path d="M2560 5490 c-11 -8 0 -10 37 -8 29 2 53 6 53 11 0 11 -73 8 -90 -3z"/>
<path d="M2670 5482 c0 -6 9 -26 21 -44 17 -28 19 -29 13 -8 -8 30 -34 69 -34
52z"/>
<path d="M2440 5466 c-35 -10 -40 -14 -25 -19 11 -3 4 -3 -16 0 -20 2 -56 -1
-80 -7 -63 -17 -215 -83 -201 -88 25 -8 11 -24 -15 -18 -18 4 -23 3 -14 -2 10
-7 5 -15 -21 -36 -19 -14 -39 -26 -44 -26 -5 0 -15 -9 -22 -20 -7 -11 -18 -20
-25 -20 -8 1 -6 5 4 13 9 7 14 18 11 25 -2 7 1 11 7 10 12 -3 71 34 71 45 0
10 -67 -27 -100 -56 -15 -14 -36 -27 -45 -29 -10 -1 -25 -14 -34 -28 -14 -22
-14 -24 0 -13 9 7 19 10 23 6 4 -4 4 0 0 10 -9 24 3 21 17 -4 8 -15 8 -19 0
-15 -6 4 -11 2 -11 -4 0 -6 -5 -8 -12 -4 -7 5 -9 2 -5 -9 4 -10 -3 -21 -19
-32 -14 -9 -23 -19 -20 -22 3 -3 -4 -14 -16 -25 -12 -10 -23 -16 -26 -14 -6 6
30 66 40 66 4 0 8 5 8 12 0 23 -37 -23 -59 -75 -13 -28 -29 -63 -36 -77 -17
-33 -55 -183 -54 -212 0 -13 13 15 28 62 15 47 35 99 44 117 23 43 79 127 89
131 4 2 4 11 1 20 -3 9 -3 14 2 10 7 -6 145 106 153 125 2 4 10 7 18 7 8 0 14
4 14 10 0 5 35 25 78 45 42 20 85 40 94 45 25 14 26 14 33 -29 7 -43 18 -55
85 -95 25 -15 88 -54 140 -86 230 -143 346 -210 363 -210 23 0 106 38 205 94
42 23 150 80 239 126 l162 82 10 50 c6 27 11 74 11 104 0 49 -2 55 -26 64 -37
14 -64 12 -64 -5 0 -8 4 -15 8 -15 4 0 14 -16 21 -36 7 -19 19 -38 28 -41 8
-3 11 -9 6 -12 -16 -12 -44 -71 -38 -81 3 -6 -1 -10 -9 -10 -9 0 -16 -6 -16
-14 0 -11 -12 -13 -54 -9 -57 5 -96 -8 -96 -32 0 -8 -5 -15 -10 -15 -6 0 -9
-3 -8 -7 1 -5 -4 -18 -12 -30 -13 -19 -24 -23 -71 -23 -38 0 -61 -5 -69 -15
-7 -8 -9 -15 -6 -15 4 0 -5 -11 -19 -25 -14 -14 -25 -30 -25 -35 0 -6 -25 -10
-55 -10 -46 0 -60 -4 -80 -24 -13 -13 -26 -22 -29 -19 -3 3 2 12 10 20 17 18
15 26 -21 82 -24 40 -27 41 -80 41 -29 0 -57 -4 -60 -10 -9 -15 -25 -12 -19 4
3 8 -6 32 -20 55 -14 22 -26 45 -26 51 0 6 -24 10 -61 9 -53 -2 -62 -5 -72
-26 -5 -12 -14 -23 -19 -23 -12 0 -10 11 6 29 13 14 12 22 -5 61 -25 55 -29
58 -104 66 -43 5 -54 9 -40 15 11 4 37 5 58 2 24 -4 37 -2 37 6 0 6 6 11 13
11 7 0 19 17 27 38 8 20 16 40 18 45 5 9 -14 8 -68 -7z m1025 -16 c3 -5 1 -10
-4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-1115 -24 c0 -2 -9
-6 -20 -9 -11 -3 -20 -1 -20 4 0 5 9 9 20 9 11 0 20 -2 20 -4z m932 -220 c3
-16 1 -23 -7 -19 -7 2 -11 13 -8 24 7 25 10 24 15 -5z m-594 -116 c-7 -10 -14
-18 -15 -16 -6 6 9 36 18 36 5 0 4 -9 -3 -20z"/>
<path d="M2511 5413 l-29 -47 23 -47 c26 -51 39 -57 103 -51 38 4 45 8 64 46
11 22 24 43 28 46 4 3 2 11 -6 18 -8 7 -14 8 -14 2 0 -5 -5 -10 -11 -10 -7 0
-9 9 -5 23 10 42 -18 67 -75 67 -48 0 -50 -1 -78 -47z m70 30 c-13 -3 -26 -13
-28 -24 -5 -18 -23 -27 -23 -12 0 16 35 43 54 42 19 -2 18 -2 -3 -6z m74 -53
c-3 -46 -16 -50 -14 -4 2 22 -1 47 -5 54 -4 8 -1 7 7 -3 8 -10 14 -31 12 -47z
m18 -44 c-10 -13 -20 -22 -22 -20 -4 4 29 44 36 44 2 0 -4 -11 -14 -24z m-139
-22 c3 -8 2 -12 -4 -9 -6 3 -10 10 -10 16 0 14 7 11 14 -7z"/>
<path d="M3238 5411 c-25 -46 -25 -46 -7 -81 11 -19 19 -40 19 -47 0 -14 49
-26 92 -21 28 3 37 11 60 53 l26 50 -26 48 -27 48 -55 -2 c-55 -2 -56 -3 -82
-48z m128 31 c12 -8 34 -46 34 -58 0 -4 -7 1 -15 12 -13 17 -14 17 -15 2 0 -9
10 -24 22 -32 12 -9 17 -16 11 -16 -20 0 -45 32 -40 52 3 10 -1 25 -10 33 -15
15 -6 20 13 7z"/>
<path d="M3070 5400 c6 -11 12 -20 14 -20 2 0 2 9 -1 20 -3 11 -9 20 -15 20
-5 0 -4 -9 2 -20z"/>
<path d="M2810 5389 c0 -5 5 -7 10 -4 6 3 10 8 10 11 0 2 -4 4 -10 4 -5 0 -10
-5 -10 -11z"/>
<path d="M3046 5355 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M3063 5314 c-33 -54 -32 -69 8 -125 17 -25 27 -29 65 -29 50 0 60 7
87 62 19 35 19 36 -5 77 -24 43 -50 57 -93 49 -13 -3 -26 0 -28 5 -2 6 -17
-12 -34 -39z m68 -6 c-14 -5 -21 -14 -18 -22 3 -7 -3 -20 -13 -29 -12 -10 -17
-24 -14 -39 2 -13 1 -16 -2 -8 -4 8 -13 23 -22 33 -14 15 -13 17 6 17 14 0 24
10 33 34 9 26 16 32 32 28 20 -5 20 -6 -2 -14z m-31 4 c0 -11 -22 -32 -32 -32
-5 0 -4 9 2 20 11 20 30 28 30 12z"/>
<path d="M2690 5298 l-22 -39 24 -47 c24 -47 25 -47 79 -50 l55 -3 24 48 c35
69 35 71 6 44 -21 -20 -26 -22 -26 -8 0 23 -20 22 -21 0 0 -10 -3 -13 -5 -6
-3 7 0 21 5 32 7 13 8 22 1 26 -5 3 -10 1 -10 -4 0 -17 -24 -13 -42 7 -41 42
-44 42 -68 0z m26 -4 c-5 -17 -3 -23 4 -19 15 9 12 -4 -4 -21 -27 -26 -30 -15
-11 44 10 31 19 28 11 -4z"/>
<path d="M3010 5305 c0 -29 -8 -32 -26 -7 -12 15 -13 15 -14 1 0 -17 26 -33
40 -24 11 7 19 55 9 55 -5 0 -9 -11 -9 -25z"/>
<path d="M2835 5280 c-3 -5 -2 -10 4 -10 5 0 13 5 16 10 3 6 2 10 -4 10 -5 0
-13 -4 -16 -10z"/>
<path d="M2941 5242 c-38 -4 -48 -12 -76 -59 -19 -32 -19 -33 5 -75 30 -54 35
-58 91 -58 40 0 49 4 65 28 10 15 17 29 17 32 -1 3 3 13 8 22 10 18 -7 68 -23
68 -4 0 -8 8 -8 19 0 21 -25 28 -79 23z m52 -19 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z"/>
<path d="M1806 5153 c-6 -14 -5 -15 5 -6 7 7 10 15 7 18 -3 3 -9 -2 -12 -12z"/>
<path d="M2145 5144 c-289 -152 -407 -484 -286 -805 31 -83 117 -218 189 -298
54 -61 180 -167 247 -208 97 -60 248 -116 374 -139 140 -24 359 -13 516 26 86
22 235 78 235 89 0 3 -48 6 -108 7 -166 1 -282 39 -414 136 -75 55 -171 155
-165 171 2 6 18 15 35 19 l32 9 0 339 0 340 -69 45 c-38 25 -72 45 -75 45 -3
0 -6 -19 -6 -43 0 -45 3 -49 78 -129 l36 -38 -1 -115 c0 -67 3 -115 9 -115 5
0 6 -5 3 -10 -4 -6 -11 -7 -17 -4 -7 5 -9 -2 -4 -19 3 -14 2 -29 -4 -32 -5 -3
-10 -19 -10 -35 0 -33 -9 -60 -20 -60 -4 0 -3 23 1 52 7 45 6 54 -11 70 -11
11 -20 32 -20 48 0 17 -5 30 -11 30 -5 0 -7 5 -3 11 4 7 8 35 10 64 2 46 -1
56 -25 79 l-28 27 2 -40 c1 -21 9 -47 18 -56 29 -29 18 -75 -18 -75 -36 0 -51
25 -35 58 21 42 14 103 -14 127 -14 11 -34 28 -46 38 -20 17 -21 25 -18 131
l3 113 -37 22 c-20 11 -39 21 -42 21 -4 0 -6 -62 -6 -138 0 -130 1 -139 23
-157 12 -11 26 -18 30 -17 5 1 6 -1 3 -6 -3 -5 13 -26 34 -47 l40 -39 0 -118
c0 -100 2 -118 16 -118 11 0 14 -8 12 -32 -3 -30 -6 -33 -38 -33 -30 0 -35 4
-38 26 -2 14 4 31 12 39 13 10 16 34 15 124 l-1 111 -54 49 -54 49 0 -45 c0
-28 6 -50 15 -58 35 -29 5 -77 -40 -66 -23 6 -26 11 -23 44 2 22 8 36 15 35 9
-2 13 49 15 203 l3 207 -24 18 c-13 11 -28 19 -32 19 -5 0 -9 -68 -9 -151 0
-115 3 -154 14 -164 7 -8 17 -11 20 -7 17 16 -9 -35 -27 -55 -24 -27 -31 -28
-51 -7 -23 22 -20 61 4 69 19 6 20 15 20 155 0 82 2 155 5 162 4 9 -5 20 -22
28 -15 8 -40 22 -55 32 -36 25 -64 23 -123 -8z m27 -51 c24 -21 23 -45 -2 -68
-16 -15 -20 -31 -20 -87 0 -45 4 -68 12 -68 6 0 9 -3 5 -6 -3 -3 4 -16 15 -29
18 -21 20 -36 19 -147 l-1 -123 53 -52 54 -52 -4 -73 c-4 -64 -2 -76 16 -95
21 -22 28 -43 14 -43 -5 0 -19 16 -32 35 -21 31 -23 42 -17 98 l6 63 -55 56
-55 56 0 124 c0 120 -1 125 -25 148 -23 21 -25 31 -25 102 0 57 -4 84 -15 94
-20 21 -19 61 3 73 24 14 33 13 54 -6z m127 -147 c14 -17 11 -65 -5 -59 -11 4
-24 -119 -24 -231 0 -49 3 -54 55 -106 l55 -54 0 -84 c0 -76 2 -86 28 -118 15
-18 33 -34 39 -34 18 0 27 -48 13 -65 -11 -13 -6 -25 25 -71 40 -57 129 -154
142 -154 5 0 15 12 23 28 16 27 15 28 -53 117 -65 85 -148 239 -163 302 -4 15
-12 34 -18 42 -8 11 -8 13 2 7 7 -4 12 -2 12 4 0 7 13 10 33 8 27 -3 33 -7 35
-32 2 -15 0 -26 -5 -23 -5 3 -15 2 -22 -2 -10 -7 -7 -22 13 -74 56 -139 131
-246 248 -351 65 -59 205 -145 271 -166 21 -7 36 -14 34 -16 -16 -16 -209 83
-286 147 l-35 28 -24 -26 -24 -26 23 -19 c13 -10 62 -38 109 -62 93 -48 216
-81 350 -96 l85 -9 -90 4 c-181 9 -356 72 -502 181 -74 55 -173 165 -195 216
-7 15 -18 28 -25 28 -21 0 -35 37 -23 60 12 22 3 47 -24 70 -12 9 -16 32 -16
95 l0 82 -55 52 -55 53 0 143 c0 114 -3 145 -15 155 -18 15 -19 42 -3 58 16
16 53 15 67 -2z m-239 -26 c11 -11 20 -27 20 -35 0 -8 -9 -20 -20 -27 -18 -12
-20 -24 -20 -125 0 -94 3 -113 15 -113 10 0 15 -10 15 -30 0 -36 -30 -56 -60
-40 -24 13 -28 65 -5 74 12 4 15 27 15 115 0 87 -3 110 -15 115 -21 8 -19 62
3 75 24 15 29 14 52 -9z m407 -72 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2
-19 0 -25z m312 -32 c-2 -2 -15 -9 -29 -15 -24 -11 -24 -11 -6 3 16 13 49 24
35 12z m-619 -102 c0 -7 -9 -18 -20 -24 -17 -9 -20 -21 -20 -80 l0 -69 53 -57
c57 -62 69 -81 43 -71 -14 6 -15 3 -6 -13 6 -11 10 -35 8 -53 -2 -35 12 -63
86 -172 110 -161 225 -268 278 -258 32 6 69 -26 63 -55 -3 -16 12 -26 73 -55
104 -47 110 -49 133 -34 17 10 23 9 40 -12 18 -22 18 -25 3 -42 -23 -25 -42
-24 -55 4 -15 33 -170 100 -227 98 -34 -2 -48 3 -63 20 -10 12 -20 26 -20 31
-1 4 -2 13 -3 18 0 6 -35 46 -77 88 -78 79 -171 199 -224 290 -19 32 -40 55
-57 61 -20 7 -28 17 -28 33 0 21 19 64 20 44 0 -10 30 13 30 23 0 3 -20 27
-45 53 l-45 47 0 74 c0 55 -4 78 -15 87 -22 19 -15 52 15 67 22 11 27 10 43
-8 9 -12 17 -27 17 -35z m466 -220 c-4 -10 6 -29 25 -52 30 -34 31 -38 26
-103 -4 -58 -2 -70 14 -85 18 -17 20 -16 33 2 10 14 11 23 4 32 -15 18 -2 28
17 12 21 -17 19 -42 -5 -63 -26 -22 -43 -22 -66 4 -15 16 -18 33 -16 92 3 69
2 73 -27 101 -33 32 -42 76 -15 76 11 0 14 -5 10 -16z m651 -730 c-3 -3 -12
-4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z"/>
<path d="M2126 5072 c-8 -13 11 -35 23 -28 16 10 14 36 -3 36 -8 0 -17 -4 -20
-8z"/>
<path d="M2246 4932 c-2 -4 -1 -14 4 -22 7 -11 12 -12 21 -3 6 6 8 16 5 22 -8
13 -23 14 -30 3z"/>
<path d="M2465 4450 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M2015 4901 c-8 -15 3 -31 21 -31 9 0 14 7 12 17 -4 20 -24 28 -33 14z"/>
<path d="M2016 4603 c-13 -14 -5 -33 14 -33 11 0 20 6 20 14 0 15 -24 28 -34
19z"/>
<path d="M2097 4734 c-14 -15 -6 -34 14 -34 14 0 19 5 17 17 -3 18 -20 27 -31
17z"/>
<path d="M1745 5095 c-4 -27 -9 -54 -10 -60 -2 -5 -5 -35 -8 -65 l-7 -55 14
45 c7 25 25 71 39 102 14 32 22 60 17 63 -4 3 -11 -3 -15 -13 -7 -14 -9 -13
-15 8 -5 21 -8 17 -15 -25z"/>
<path d="M2546 4964 c-3 -9 -6 -53 -6 -98 0 -82 0 -82 36 -114 51 -45 55 -40
9 9 -22 23 -34 39 -27 35 10 -6 12 10 11 72 -1 44 1 85 5 90 3 5 0 12 -8 15
-8 3 -17 -1 -20 -9z"/>
<path d="M2591 4871 c-2 -88 -1 -89 30 -115 17 -14 28 -26 24 -26 -3 0 9 -16
28 -36 34 -37 34 -38 35 -132 0 -73 4 -98 16 -110 15 -15 16 -15 16 0 0 9 -6
19 -12 21 -9 4 -8 6 3 6 13 1 15 16 12 113 l-4 113 -55 56 c-55 56 -56 56 -53
113 2 48 -1 59 -18 71 -20 14 -21 13 -22 -74z m69 -106 c7 -9 8 -15 2 -15 -5
0 -12 7 -16 15 -3 8 -4 15 -2 15 2 0 9 -7 16 -15z"/>
<path d="M2325 4741 c-3 -5 -1 -12 5 -16 12 -7 30 2 30 16 0 12 -27 12 -35 0z"/>
<path d="M4633 4701 c-41 -26 -64 -61 -65 -100 -2 -49 24 -75 98 -102 80 -30
96 -48 74 -86 -29 -51 -112 -55 -168 -8 -29 24 -30 24 -47 5 -15 -17 -16 -22
-4 -36 22 -26 90 -54 134 -54 79 0 149 58 149 125 0 45 -23 68 -92 96 -78 30
-96 48 -83 82 6 14 20 31 32 38 29 15 105 6 129 -16 16 -15 22 -15 35 -5 21
18 18 32 -13 55 -40 29 -137 32 -179 6z"/>
<path d="M5016 4712 c-8 -14 -86 -346 -86 -368 0 -11 8 -14 27 -12 26 3 28 7
59 148 l31 145 21 -47 c11 -25 29 -69 39 -97 10 -28 21 -51 25 -51 4 0 42 41
84 90 72 85 104 111 90 74 -5 -14 -37 -137 -61 -242 -5 -21 -2 -23 22 -20 27
3 29 7 65 153 21 83 40 168 43 191 l7 40 -36 -4 c-31 -4 -46 -16 -113 -98 -43
-52 -80 -94 -83 -94 -3 0 -13 26 -24 57 -37 115 -53 143 -80 143 -14 0 -27 -4
-30 -8z"/>
<path d="M5683 4712 c-6 -4 -24 -25 -39 -47 -61 -90 -190 -282 -206 -307 l-18
-28 29 0 c24 0 35 8 58 45 l28 45 105 -3 105 -2 5 -40 c4 -35 9 -40 33 -43 32
-4 32 -9 7 114 -56 272 -54 267 -75 270 -11 2 -26 0 -32 -4z m26 -134 c7 -35
15 -73 18 -85 5 -22 3 -23 -72 -23 -42 0 -75 4 -73 9 7 17 103 161 108 161 3
0 12 -28 19 -62z"/>
<path d="M7419 4681 c-13 -20 -70 -103 -126 -185 -57 -82 -103 -153 -103 -158
0 -4 11 -8 25 -8 17 0 33 12 55 45 l31 45 104 0 c102 0 105 -1 105 -22 0 -47
12 -68 36 -68 13 0 24 6 24 13 0 7 -16 91 -35 187 -19 96 -35 178 -35 183 0 4
-13 6 -29 5 -20 -1 -35 -12 -52 -37z m45 -63 c18 -84 27 -140 23 -144 -2 -3
-37 -4 -76 -2 l-72 3 53 82 c29 45 56 82 60 83 4 0 10 -10 12 -22z"/>
<path d="M8060 4524 l-130 -194 32 0 c28 1 37 7 60 45 l27 45 100 0 c110 0
103 4 113 -65 4 -24 58 -35 58 -12 0 18 -70 359 -76 368 -2 4 -15 7 -28 7 -21
0 -45 -30 -156 -194z m159 54 c6 -35 14 -73 17 -85 6 -22 4 -23 -71 -23 l-77
0 23 38 c49 80 84 132 90 132 4 0 12 -28 18 -62z"/>
<path d="M6005 4633 c-10 -43 -28 -122 -41 -175 -30 -122 -30 -128 1 -128 19
0 26 7 31 28 20 87 26 102 42 103 9 0 28 2 42 5 33 5 40 -1 76 -71 27 -52 35
-60 63 -63 17 -2 31 0 31 3 0 4 -16 34 -35 66 -39 67 -42 79 -20 79 35 0 77
33 96 73 27 60 24 84 -15 123 l-34 34 -110 0 -111 0 -16 -77z m231 2 c13 -20
15 -33 7 -58 -12 -44 -52 -62 -138 -62 -79 0 -77 -5 -49 93 l15 52 74 0 c69 0
76 -2 91 -25z"/>
<path d="M6420 4685 c0 -24 3 -25 61 -25 53 0 60 -2 55 -17 -5 -18 -58 -234
-70 -285 -6 -26 -4 -28 24 -28 17 0 30 5 30 13 0 6 16 81 36 165 l36 152 64 0
c35 0 64 4 64 9 0 5 3 16 6 25 5 14 -12 16 -150 16 l-156 0 0 -25z"/>
<path d="M6835 4638 c-50 -214 -65 -284 -65 -296 0 -12 21 -13 108 -11 100 4
113 7 158 34 69 43 109 111 109 186 0 65 -18 98 -75 137 -28 19 -46 22 -126
22 l-92 0 -17 -72z m198 11 c31 -14 57 -59 57 -97 0 -100 -84 -172 -200 -172
-54 0 -61 2 -56 18 14 44 56 229 56 245 0 14 10 17 60 17 32 0 70 -5 83 -11z"/>
<path d="M7690 4685 c0 -24 3 -25 55 -25 42 0 55 -4 55 -15 0 -13 -38 -175
-60 -256 -15 -54 -13 -61 17 -57 23 2 29 10 36 43 5 22 19 83 32 135 12 52 26
107 29 123 6 26 9 27 71 27 36 0 65 4 65 9 0 5 3 16 6 25 5 14 -12 16 -150 16
l-156 0 0 -25z"/>
<path d="M2407 4614 c-9 -10 4 -34 19 -34 8 0 14 9 14 20 0 19 -19 27 -33 14z"/>
<path d="M2614 4579 c-8 -14 18 -31 30 -19 9 9 0 30 -14 30 -5 0 -12 -5 -16
-11z"/>
<path d="M2547 4384 c-14 -15 -6 -34 14 -34 14 0 19 5 17 17 -3 18 -20 27 -31
17z"/>
<path d="M4470 4035 c0 -78 3 -95 15 -95 12 0 15 17 15 95 0 78 -3 95 -15 95
-12 0 -15 -17 -15 -95z"/>
<path d="M4567 4123 c-2 -5 -2 -14 -1 -20 1 -7 2 -49 3 -93 1 -58 4 -79 14
-77 7 1 14 27 17 72 l5 70 49 -68 c28 -37 56 -67 63 -67 10 0 13 23 13 95 0
78 -3 95 -15 95 -12 0 -15 -14 -15 -67 l0 -68 -47 67 c-43 60 -75 82 -86 61z"/>
<path d="M4790 4116 c0 -9 12 -16 28 -18 27 -3 27 -4 30 -80 2 -60 6 -78 17
-78 12 0 15 17 15 80 l0 80 30 0 c20 0 30 5 30 15 0 12 -15 15 -75 15 -58 0
-75 -3 -75 -14z"/>
<path d="M4990 4035 l0 -95 70 0 c56 0 70 3 70 15 0 12 -13 15 -56 15 -52 0
-55 1 -52 23 3 19 10 22 51 25 33 2 47 7 47 18 0 10 -13 14 -51 14 -47 0 -50
2 -47 23 3 19 10 23 58 27 79 7 68 24 -17 28 l-73 3 0 -96z"/>
<path d="M5190 4035 l0 -95 65 0 c52 0 65 3 65 16 0 12 -10 15 -47 13 l-48 -3
-3 82 c-2 64 -6 82 -17 82 -12 0 -15 -18 -15 -95z"/>
<path d="M5380 4035 l0 -95 65 0 c51 0 65 3 65 15 0 11 -12 15 -50 15 l-50 0
0 80 c0 64 -3 80 -15 80 -12 0 -15 -17 -15 -95z"/>
<path d="M5570 4035 c0 -78 3 -95 15 -95 12 0 15 17 15 95 0 78 -3 95 -15 95
-12 0 -15 -17 -15 -95z"/>
<path d="M5705 4118 c-31 -18 -44 -40 -45 -76 0 -71 55 -121 118 -107 43 9 63
35 58 76 -3 32 -5 34 -42 34 -28 0 -39 -4 -39 -15 0 -8 10 -16 23 -18 32 -5
29 -38 -5 -47 -59 -14 -103 58 -68 112 15 22 22 25 61 20 48 -5 66 6 35 22
-26 14 -71 13 -96 -1z"/>
<path d="M5894 4117 c-2 -7 -4 -52 -2 -98 l3 -84 70 0 c56 0 70 3 70 15 0 11
-12 15 -45 17 -25 1 -51 2 -58 2 -8 1 -12 10 -10 24 3 19 10 22 51 25 33 2 47
7 47 18 0 10 -13 14 -51 14 -47 0 -50 2 -47 23 3 19 10 23 58 27 77 7 69 24
-13 28 -50 2 -69 -1 -73 -11z"/>
<path d="M6090 4035 c0 -88 2 -95 20 -95 17 0 19 8 22 67 l3 66 44 -64 c73
-105 81 -102 81 27 0 77 -3 94 -15 94 -12 0 -15 -13 -15 -60 0 -33 -4 -60 -9
-60 -4 0 -20 18 -35 40 -40 61 -59 80 -78 80 -16 0 -18 -11 -18 -95z"/>
<path d="M6320 4116 c0 -9 11 -16 28 -18 29 -3 27 6 31 -135 1 -14 7 -23 16
-23 12 0 15 15 15 79 0 78 1 80 25 83 54 7 27 23 -42 26 -59 2 -73 0 -73 -12z"/>
<path d="M6624 4105 c-15 -23 -15 -27 -1 -49 9 -13 28 -27 44 -31 34 -8 53
-23 53 -41 0 -20 -38 -27 -71 -14 -34 14 -48 7 -29 -14 20 -25 76 -31 105 -12
46 31 21 106 -35 106 -9 0 -24 6 -34 13 -17 13 -17 14 -1 31 10 10 24 14 34
10 38 -16 51 -16 51 -1 0 18 -21 27 -66 27 -25 0 -38 -6 -50 -25z"/>
<path d="M6829 4099 c-66 -71 -4 -185 89 -164 37 8 60 32 72 75 28 96 -92 162
-161 89z m105 -10 c19 -15 26 -30 26 -55 0 -80 -93 -100 -121 -27 -17 44 16
98 62 102 4 1 18 -8 33 -20z"/>
<path d="M7057 4123 c-2 -5 -3 -48 -3 -98 l1 -90 65 0 c51 0 65 3 65 15 0 11
-11 15 -47 13 l-48 -1 0 84 c0 66 -3 84 -14 84 -8 0 -17 -3 -19 -7z"/>
<path d="M7237 4123 c-3 -5 -4 -38 -3 -75 1 -56 5 -71 25 -92 41 -44 112 -28
131 30 15 44 7 138 -12 142 -11 2 -14 -13 -16 -70 -2 -54 -7 -76 -19 -85 -46
-35 -73 -1 -73 88 0 53 -3 69 -14 69 -8 0 -17 -3 -19 -7z"/>
<path d="M7450 4115 c0 -10 10 -15 30 -15 l30 0 0 -80 c0 -64 3 -80 15 -80 12
0 15 16 15 80 l0 80 30 0 c20 0 30 5 30 15 0 12 -15 15 -75 15 -60 0 -75 -3
-75 -15z"/>
<path d="M7659 4128 c-5 -19 -6 -189 0 -192 4 -3 13 -1 19 3 18 11 12 183 -5
189 -7 2 -13 2 -14 0z"/>
<path d="M7788 4113 c-36 -22 -49 -62 -37 -106 16 -60 65 -86 124 -67 41 13
65 52 65 104 0 69 -88 108 -152 69z m107 -36 c21 -30 18 -67 -7 -94 -56 -60
-137 14 -97 88 21 41 78 44 104 6z"/>
<path d="M8000 4035 c0 -76 3 -95 15 -95 10 0 15 15 17 57 2 31 8 58 13 60 6
1 22 -16 37 -40 33 -52 67 -89 76 -83 4 3 8 47 7 98 0 76 -3 93 -15 93 -11 0
-15 -13 -17 -50 -1 -27 -2 -56 -2 -64 -1 -8 -12 1 -26 20 -13 19 -34 49 -47
66 -13 18 -31 33 -40 33 -16 0 -18 -11 -18 -95z"/>
<path d="M8248 4119 c-18 -10 -24 -54 -10 -75 4 -6 24 -17 45 -24 72 -23 60
-71 -12 -49 -45 13 -61 8 -41 -15 19 -24 76 -31 104 -13 51 34 34 88 -34 108
-27 8 -40 18 -40 30 0 22 24 31 56 19 34 -13 53 -2 29 17 -22 15 -73 17 -97 2z"/>
<path d="M2908 3613 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
</g>
</svg>



    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
